import { render } from "./testmq_page.vue?vue&type=template&id=1af77f49"
import script from "./testmq_page.vue?vue&type=script&lang=js"
export * from "./testmq_page.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__